// @flow
import React from 'react';
import PropTypes from 'prop-types';

import '../tile/HelpTile.scss';

export type Contact = {
  firstName: string,
  lastName: string,
  phone: string,
  email: string,
  onClick: () => null,
};

const ContactComponent = ({ firstName, lastName, phone, email, onClick }: Contact) => (
  <section className="help-tile__contact">
    {(firstName || lastName) && <p>{`${firstName} ${lastName}`}</p>}
    {phone && <p>{phone}</p>}
    {email && (
      <p>
        <a href={`mailto:${email}`} onClick={onClick}>
          {email}
        </a>
      </p>
    )}
  </section>
);

ContactComponent.defaultProps = {
  firstName: null,
  lastName: null,
  phone: null,
  email: null,
};

ContactComponent.propTypes = {
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  phone: PropTypes.string,
  email: PropTypes.string,
  onClick: PropTypes.func.isRequired,
};

export default ContactComponent;
